import { render, staticRenderFns } from "./impressumcontent.vue?vue&type=template&id=4666e6d4&scoped=true&"
import script from "./impressumcontent.vue?vue&type=script&lang=js&"
export * from "./impressumcontent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4666e6d4",
  null
  
)

export default component.exports